export default __webpack_public_path__ + "static/media/Black.6e2e871c.png";